<div class="d-lg-flex" *ngIf="outtageSetting?.value">
  <p class="supportText">
    <span class="wrapText">
      <div [innerHTML]="outtageSetting.value"></div>
    </span>
  </p>
</div>